import CodeProductList from './pages/ListPage.vue'
import CodeProductDetail from './pages/FormPage.vue'
import CodeProductIndex from './pages/IndexPage.vue'

export default [
  {
    path: '/code_product',
    component: CodeProductIndex,
    redirect: '/code_product/list',
    name: 'code_product',
    children: [
      {
        path: 'list',
        component: CodeProductList,
        name: 'code_product.list'
      },
      {
        path: 'create',
        component: CodeProductDetail,
        name: 'code_product.create',
        props: {create: true},
      },
      {
        path: 'edit/:id',
        component: CodeProductDetail,
        name: 'code_product.edit',
        props: {create: false},
      },
    ],
  },
]
